// extracted by mini-css-extract-plugin
export default {"Alert":"_Alert--v97Iv","LimitedUserContainer":"_LimitedUserContainer--zoKRx"};